import { SvgIcon } from "@mui/material";

function UploadIcon(props) {
  return (
    <SvgIcon viewBox="0 0 76 77" fill="none" {...props}>
      <path
        d="M68.6533 54.2067L58.7416 31.0584C55.3849 23.205 49.2099 22.8884 45.0616 30.3617L39.0766 41.16C36.0366 46.6384 30.3683 47.1134 26.4416 42.205L25.7449 41.3184C21.6599 36.1884 15.8966 36.8217 12.9516 42.68L7.50493 53.605C3.67326 61.205 9.21493 70.1667 17.7016 70.1667H58.1083C66.3416 70.1667 71.8833 61.775 68.6533 54.2067Z"
        stroke="#9AA0A5"
        strokeWidth="4.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.0703 25.8333C27.317 25.8333 31.5703 21.58 31.5703 16.3333C31.5703 11.0866 27.317 6.83334 22.0703 6.83334C16.8236 6.83334 12.5703 11.0866 12.5703 16.3333C12.5703 21.58 16.8236 25.8333 22.0703 25.8333Z"
        stroke="#9AA0A5"
        strokeWidth="4.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default UploadIcon;
